import { render } from "./ListadoCuestionariosView.vue?vue&type=template&id=3afbaccf"
import script from "./ListadoCuestionariosView.vue?vue&type=script&lang=js"
export * from "./ListadoCuestionariosView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__